<div class="lokos-input lokos-custom-select">
    @if (label) {
        <mat-label>
            {{ label | translate }}
            <span class="required">{{ required ? '*' : '' }}</span>
        </mat-label>
    }
    <mat-form-field appearance="outline">
        <mat-select
            [placeholder]="placeholder | translate"
            [value]="value"
            [formControl]="control"
            [required]="required"
            [multiple]="multiSelect"
            (selectionChange)="onSelectionChange($event)"
            [panelClass]="'selectbox-white-panel'"
        >
            @if (countField && !multiSelect) {
                <mat-select-trigger>{{ getSelectedDisplay() }}</mat-select-trigger>
            }
            @if (multiSelect) {
                <mat-option [value]="'selectAll'">
                    {{
                        allSelected
                            ? ('Deselect All' | translate)
                            : ('Select All' | translate)
                    }}
                </mat-option>
            }
            @for (option of displayOptionsList; track $index) {
                <mat-option [value]="getName ? option[getName] : option">
                    <span class="lokos-option-row">
                        <span>{{ getOptionDisplay(option) }}</span>
                        @if (countField && option[countField] > 0) {
                            <span class="lokos-count-badge">{{
                                option[countField]
                            }}</span>
                        }
                        @if (option.loanExist) {
                            <img
                                src="https://cdn.lokos.in/assets/img/right-icon.svg"
                                alt=""
                            />
                        }
                    </span>
                </mat-option>
            }
        </mat-select>
    </mat-form-field>
    @if (control.invalid && (control.dirty || control.touched)) {
        <mat-error>{{ getErrorMessage() }}</mat-error>
    }
</div>
